import { gql } from "@apollo/client";

const APROBAR_VALIDACION = gql`
  mutation AprobarValidacionVisita($input: VisitaHonorarioInput!) {
    aprobarValidacionVisita(input: $input){
    idVisitaHonorario
    }
  }
`;

export default APROBAR_VALIDACION;